// OptiFlow for Komatsu — the partner co-brand lockup (Miles, 2026-09-24).
// The Komatsu wordmark path is the public-domain SVG from Wikimedia Commons
// ("File:Komatsu company logos.svg"); its colour reads the `--partner-mark`
// token (Komatsu blue in light, a white reverse in dark).

const KOMATSU_PATH =
  'M159 33.2c-2.9.1-5.7-.7-7.9-2.5-2.1-1.9-3.2-4.6-3-7.4v-15h9.7v15c0 .7.6 1.3 1.3 1.3.7 0 1.2-.6 1.3-1.3v-15h9.7v15c0 3.2-1 5.7-3 7.4-2.4 1.8-5.3 2.7-8.1 2.5zm-121.3 0c-7-.1-12.7-5.8-12.6-12.9-.2-7 5.4-12.8 12.4-12.9 7-.2 12.8 5.4 12.9 12.4v.6c0 3.4-1.3 6.7-3.7 9.1-2.4 2.4-5.6 3.7-9 3.7zm0-16.5c-2 0-3.7 1.6-3.7 3.6s1.6 3.7 3.6 3.7 3.7-1.6 3.7-3.6v-.1c0-2-1.6-3.6-3.6-3.6zm97.6 16.5c-4.1 0-6.9-1.2-10.4-3.2l2.7-6.4s4 2.6 6.7 2.6c.3 0 .6 0 .9-.1.5-.1.8-.5.8-1s-.2-.9-.7-1.1c-.5-.2-1.1-.4-1.6-.5-1.9-.5-4.9-1.2-6.4-4.1-1.7-3.2-1-7.1 1.7-9.4 2.1-1.7 4.7-2.6 7.4-2.6h.5c3 .1 5.9 1 8.5 2.7l-2.7 6.4c-1.8-1-4.2-2.1-5.7-2.1-.8 0-1.2.3-1.3.9-.1.9.8 1.2 2.3 1.6 1.3.3 2.5.7 3.7 1.3 2.9 1.7 4.4 5.1 3.5 8.4-.4 1.9-1.5 3.5-3.1 4.6-1.9 1.4-4.3 2.1-6.8 2zM9.8 32.3H0V8.4h9.8V20L15 8.4h11.1l-5.6 11.7 5.9 12.2H15.3L9.8 20.1v12.2zm50 0H51l3.6-23.9h8.9l3 9.6 3-9.6h8.9l3.3 22.5 7.6-22.5H99l8.2 23.9H97L94.1 21l-2.9 11.3H73l-1.3-9.1-2.5 9.1h-5.7L61 23.2l-1.2 9.1zm60 0H110v-15h-5.7V8.4h15.4V.8h9.1v9.5h-9.1l.1 22z';

export const PRODUCT_NAME = 'OptiFlow';
export const PARTNER_NAME = 'Komatsu';
export const PRODUCT_TITLE = `${PRODUCT_NAME} for ${PARTNER_NAME}`;

/** The Komatsu wordmark at a given cap height (px); width follows the 170:34 artwork. */
export function KomatsuMark({ height = 12, className }: { height?: number; className?: string }) {
  return (
    <svg
      role="img"
      aria-label={PARTNER_NAME}
      viewBox="0 0 170 34"
      height={height}
      width={(height * 170) / 34}
      className={className}
      style={{ color: 'var(--partner-mark)', display: 'inline-block', flexShrink: 0 }}
    >
      <path d={KOMATSU_PATH} fill="currentColor" />
    </svg>
  );
}

/** "for [KOMATSU]" — sits after the OptiFlow wordmark on its baseline. */
export function ForPartner({ height = 12, className }: { height?: number; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-[0.35em] ${className ?? ''}`}>
      <span className="font-normal text-muted">for</span>
      <KomatsuMark height={height} />
    </span>
  );
}
